import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/components/ui/resizable/components";
import { STAGED_FILES_SNAPSHOT_ID } from "@/constants";
import { useMedia } from "@/hooks/useMedia";
import { useActiveSnapshotId } from "@/lib/hooks/useActiveSnapshot";
import { useFilesystemStore } from "@/state/stores";
import { FileList } from "./FileList";
import { FileOutput } from "./FileOutput";

export function FilesystemView() {
  const activeSnapshotId = useActiveSnapshotId();

  const hasFiles = useFilesystemStore((state) => {
    if (activeSnapshotId === STAGED_FILES_SNAPSHOT_ID) {
      return state.stagedFiles.length > 0;
    }

    const files = state.filesBySnapshotId[activeSnapshotId];
    return files && files.length > 0;
  });

  const isNarrow = useMedia("(max-width: 1728px)");

  return (
    <ResizablePanelGroup direction={isNarrow ? "vertical" : "horizontal"}>
      {hasFiles && (
        <>
          <ResizablePanel defaultSize={20} minSize={6}>
            <FileList />
          </ResizablePanel>

          <ResizableHandle />
        </>
      )}

      <ResizablePanel className="[&>pre]:h-[calc(100%-2.5rem)]">
        {hasFiles === false ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-center text-muted-foreground">
              No code yet—once the agent cooks something, it'll show up here.
            </div>
          </div>
        ) : (
          <FileOutput />
        )}
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
